export const authFns = import(/* webpackChunkName: "firebase-auth" */ 'firebase/auth')
